module.exports = __webpack_public_path__ + "img/my-theater-films.6df79fd.png";